import { Badge } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { AwardCriterionType } from "../../../autogen/bff-api";
import { isEnvironmentCriterionType } from "../buyer/wizard/utils/publicProcurementOptions";

// The three environment sub-types differ only in how the § 5b weighting was met, which is an
// authoring concern -- a reader sees "Miljø".
const family = (type: AwardCriterionType): AwardCriterionType =>
  isEnvironmentCriterionType(type) ? AwardCriterionType.QualityEnvironmentalCriteria : type;

// The type of an award criterion, as the pill that heads its group. Sibling of CriterionTypeBadge,
// which does the same for a qualification criterion -- except the type is told by its label here, not
// by its colour, so every pill on the card reads as one family.
export const AwardCriterionTypeBadge = ({ type }: { type: AwardCriterionType }) => {
  const { t } = useTranslation();
  return (
    <Badge
      bg="smStatusOkBg"
      color="smStatusOkText"
      textTransform="uppercase"
      px="2"
      py="0.5"
      borderRadius="md"
      w="fit-content"
      flexShrink={0}
    >
      {t(family(type))}
    </Badge>
  );
};
